import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=515ab4ac&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=515ab4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ab4ac",
  null
  
)

export default component.exports